import * as React from 'react'

import {useFetchEffect} from '../../../../hocs/withEffect'
import {useIsQueueSelected} from '../../../../hooks/routes'
import {getIsSakuraUI} from '../../../../selectors'
import {subscribeonStatisticsUpdates} from '../../../../utils/subscriber'
import {headerQueueLinkHint} from '../../../packages/Hints/HintItems/Hints.navigation'
import {useHint} from '../../../packages/Hints/Hints.hooks'
import {LINKS} from '../Header.constants'
import {getTopNavHelperData} from '../Header.utils'

import HeaderLinkHost from './Links.host'
import type {StatisticsUpdateData} from './Links.types'
import {isActiveClassicUILink} from './Links.utils'

import styles from './Links.css'

import {useAppSelector} from 'src/hooks/react-redux'

const QueueLink = () => {
  useHint(headerQueueLinkHint)
  const isSakuraUI = useAppSelector(getIsSakuraUI)
  const [statistics, setStatistics] = React.useState<StatisticsUpdateData | null | undefined>(null)
  const queuePartSelected = useIsQueueSelected()
  const active = isSakuraUI ? queuePartSelected : isActiveClassicUILink('queue')
  const buildQueueSize = statistics?.buildQueueSize ?? getTopNavHelperData().queue
  useFetchEffect(
    () =>
      subscribeonStatisticsUpdates((data: StatisticsUpdateData | null | undefined) =>
        setStatistics(data),
      ),
    [],
  )
  const postLink = React.useMemo(
    () => (
      <span data-hint-container-id={headerQueueLinkHint.id} className={styles.counter}>
        {buildQueueSize}
      </span>
    ),
    [buildQueueSize],
  )
  return React.useMemo(
    () => (
      <div className={styles.container}>
        <HeaderLinkHost
          active={active}
          to={LINKS.buildQueue}
          className={styles.link}
          title={'Queue'}
        >
          {'Queue'}
        </HeaderLinkHost>
        <div className={styles.postLink}>{postLink}</div>
      </div>
    ),
    [active, postLink],
  )
}

export default React.memo(QueueLink)
